import { FC, ReactNode, CSSProperties, useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const ONOSelect3: FC<{
  open: boolean;
  anchorRef: React.RefObject<HTMLDivElement>;
  children: ReactNode;
  onClose: () => void;
  className?: string;
  style?: CSSProperties;
}> = ({ open, anchorRef, children, onClose, className = "", style = {} }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open && anchorRef?.current && dropdownRef?.current) {
      const rect = anchorRef?.current.getBoundingClientRect();

      Object.assign(dropdownRef.current.style, {
        position: "fixed",
        top: rect.bottom + "px",
        left: rect.left + 10 + "px",
        width: rect.width + "px",
        zIndex: 5000,
      });
    }
  }, [open]);

  if (!open) return null;

  return createPortal(
    <>
      <div
        ref={dropdownRef}
        className={`bg-white border shadow-lg rounded-md overflow-auto ${className}`}
        style={{ maxHeight: "20rem", ...style }}
      >
        {children}
      </div>

      {/* backdrop */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 4999,
        }}
      />
    </>,
    document.body
  );
};

export default ONOSelect3;
